/* eslint-disable no-mixed-spaces-and-tabs */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = { value: '' };
  }
  componentWillMount() {
    const { onChangeOption, selectedOption } = this.props;
    this.props.onChangeOption(selectedOption);
  }
  handleChange(event) {
    this.setState({ value: event.target.value });
    this.props.onChangeOption(event.target.value);
  }
  render() {
    const { onChangeOption, list, selectedOption, className } = this.props;
    const listItems = list.map(item => <option key={item.name || item.duration} className="GalleryItem" value={item.id || item.duration}>{item.name || item.duration}</option>);
    return (<select className={className} value={selectedOption} onChange={this.handleChange.bind(this)}>{listItems}</select>);
  }
}
